import React from "react"
import InputMask from "react-input-mask"
import Text from "../../../_components/Text"
import Modal from "../../../_components/Modal"
import Button from "../../../_components/Button"
import LoadingInput from "../../../_components/LoadingInput"
import TableData from "../../../_components/TableData"
import { setCookieByName } from "../../../utils"
import { getUserIndications, createInviteLink, getUser, updateUser } from "../../../api/users"
import { toast } from "react-toastify"

export default props => {
    const ref = React.useRef(null)
    const [user, setUserData] = React.useState({})
    const [loading, setLoading] = React.useState(false)

    function onSubmit(e) {
        e.preventDefault()
        user.phone = user.phone.replace(/[^\d,]/g, "")
        console.debug(user.phone)
        const data = {
            ...user,
            timezone: "America/Sao_Paulo"
        }
        setLoading(true)
        updateUser(data)
            .then(resp => {
                toast.success("Dados atualizados!", {
                    toastId: "toast-user-has-ben-editted!"
                })
                localStorage.setItem("easygestorweb_userdata", JSON.stringify(resp))
                setCookieByName("username", resp.name)
                setTimeout(() => location.reload(), 2000)
            })
            .catch(error => {
                if (error.email) {
                    if (error.email[0] === "Enter a valid email address.") {
                        toast.success("O email informado é inválido!", {
                            toastId: "toast-user-has-invalid-email-sent"
                        })
                        return
                    }
                    if (error.email[0] === "User with this Email already exists.") {
                        toast.success("Este email já está sendo utilizado.!", {
                            toastId: "toast-user-has-already-exists"
                        })
                        return
                    }

                }
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false)
                }, 2500)
            })
    }
    function init() {
        if (window.localStorage.getItem("easygestorweb_userdata")) {
            setUserData(JSON.parse(window.localStorage.getItem("easygestorweb_userdata") || {}))
        }
    }
    function onChange(e) {
        setUserData({
            ...user,
            [e.target.name]: e.target.value
        })
    }
    React.useEffect(init, [ref.current])
    return <div className="container">
        <form action="" onSubmit={onSubmit} ref={ref}>
            <div className="row">
                <div className="col-12 my-3">
                    <Text>
                        Olá, <strong>{user.name}!</strong>.
                    </Text>
                </div>

                <div className="col-md-4">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Nome de usuário
                            </Text>
                        </div>
                        <LoadingInput
                            loading={loading}
                            name="name"
                            onChange={onChange}
                            value={user.name} />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                E-mail de acesso
                            </Text>
                        </div>
                        <LoadingInput
                            name="email"
                            loading={loading}
                            onChange={onChange}
                            maxLenght={150}
                            value={user.email} />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Telefone
                            </Text>
                        </div>
                        <InputMask
                            name="phone"
                            onChange={onChange}
                            value={user.phone}
                            disabled={loading}
                            mask="(99) 99999-9999"
                            className="form-control" />
                    </div>
                </div>
                <div className="col-md-4">
                    <Button
                        loading={loading}
                        disabled={loading}
                        onClick={onSubmit} >
                        Salvar
                    </Button>
                </div>
            </div>
        </form >
        {
            user.share_link
                ? <AffiliateSection data={user} />
                : <ActivateAffiliate data={user} />
        }
    </div>
}

function AffiliateSection(props) {

    const [rewards, setRewardsData] = React.useState({ actives_invites: 0, available_rewards: 0, invites: 0 })
    const [rewardHistory, setRewardHistory] = React.useState([])
    const [invites, setInvites] = React.useState([])

    function copy() {
        const input = document.getElementById(`shared-link-${props.data.id}`)
        navigator.clipboard.writeText(input.value)
            .then(() => {
                toast.success("O link foi copiado!", {
                    toastId: "toast-user-changed-to-affiate"
                })
            })
    }
    function init() {
        if (props.data.id) {
            getUserIndications()
                .then(resp => {
                    setRewardHistory(resp.available_rewards)
                    setInvites(resp.actives_invites)
                    resp = {
                        actives_invites: resp.actives_invites.length,
                        available_rewards: resp.available_rewards.length,
                        total: "R$ 0,00"
                    }
                    setRewardsData(resp)
                })
        }
    }
    React.useEffect(init, [props.data])
    return <div className="row py-3">
        <div className="col-12">
            <Text>
                Link de afiliado
            </Text>
            <div className="d-flex">
                <LoadingInput id={`shared-link-${props.data.id}`} className="" disabled value={props.data.share_link} />
                <Button
                    onClick={copy}
                    className="p-2"
                    as="text"
                    title="Copiar link">
                    <i className="fas fa-copy" />
                </Button>
            </div>
        </div>
        <div className="col-12">
            <div className="my-2">
                <Text>
                    Informações de Afiliação
                </Text>
            </div>
        </div>
        <div className="col-12 my-3">
            <TableData
                data={[rewards]}
                tHead={["Se cadastraram com o link" ]}
                tBodyKeys={["actives_invites"]}
            />
        </div>
        <div className="col-12">
            <div className="my-2">
                <Text>
                    Usuários cadastrados com o link
                </Text>
            </div>
        </div>
        <div className="col-12 my-3">
            <TableData
                data={[...invites]}
                tHead={["Email"]}
                tBodyKeys={["email"]}
            />
        </div>
        <div className="col-12">
            <div className="my-2">
                <Text>
                    Histórico
                </Text>
            </div>
        </div>
        <div className="col-12 my-3">
            <TableData
                data={[...rewardHistory]}
                tHead={["Data", "Descrição", "Status"]}
                tBodyKeys={["available_at", "description", "status"]}
            />
        </div>
    </div>
}

function ActivateAffiliate(props) {
    const [show, setShow] = React.useState(false)
    const [data, setData] = React.useState({})

    function create() {
        createInviteLink().then(() => {
            getUser().then(user => {
                window.localStorage.setItem("easygestorweb_userdata", JSON.stringify(user))
                location.reload()
            })
        })
    }

    function onHide() {
        setShow(false)
    }
    return <div className="row">
        <div className="col-12 text-center">
            <Button as="text" onClick={() => setShow(true)}>
                Quero ser afiliado
            </Button>
        </div>
        <Modal title="Criar Link de afiliado" show={show} onHide={onHide}>
            <Text className="d-none">Selecione o seu perfil de afiliado</Text>
            <div className="d-flex justify-content-center">
                <Button onClick={create} >
                    Obter link de afiliado
                </Button>
            </div>
        </Modal>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/User/Profile/index.jsx